/* Product state has one owner; details use native keyboard/touch behavior. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-exact-product]').forEach(root => {
      if (root.dataset.productRepairReady) return;
      root.dataset.productRepairReady = 'true';
      const find = selector => root.querySelector(selector);
      const image = find('[data-main-product-image]');
      const imageKey = src => { try { return new URL(src, location.origin).pathname; } catch { return src; } };
      function showImage(src, alt) {
        if (!image || !src) return;
        const widths = [480, 800, 1200, 1800];
        image.srcset = widths.map(width => {
          const url = new URL(src, location.origin);
          url.searchParams.set('width', String(width));
          return `${url.href} ${width}w`;
        }).join(', ');
        image.src = src;
        image.alt = alt || root.querySelector('h1')?.textContent || '';
        root.querySelectorAll('[data-image-src]').forEach(button => {
          const active = imageKey(button.dataset.imageSrc) === imageKey(src);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
      root.querySelectorAll('[data-image-src]').forEach(button => {
        button.addEventListener('click', () => showImage(button.dataset.imageSrc, button.dataset.imageAlt));
      });
      // Swipe only the main image; preserve vertical page scrolling and pinch zoom.
      const stage = find('.mfc-pdp2__stage');
      let gesture = null;
      stage?.addEventListener('touchstart', event => {
        gesture = event.touches.length === 1 && matchMedia('(max-width: 989px)').matches
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      stage?.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) gesture = null;
      }, { passive: true });
      stage?.addEventListener('touchcancel', () => { gesture = null; }, { passive: true });
      stage?.addEventListener('touchend', event => {
        const start = gesture;
        gesture = null;
        if (!start || event.touches.length || event.changedTouches.length !== 1) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        const thumbs = [...root.querySelectorAll('[data-image-src]')];
        if (thumbs.length < 2) return;
        const current = thumbs.findIndex(button => imageKey(button.dataset.imageSrc) === imageKey(image.src));
        const next = thumbs[(Math.max(0, current) + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
        showImage(next.dataset.imageSrc, next.dataset.imageAlt);
        const strip = find('[data-thumbs]');
        if (strip) strip.scrollTo({ left: next.offsetLeft - strip.offsetLeft - (strip.clientWidth - next.offsetWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, { passive: true });
      const strip = find('[data-thumbs]');
      find('[data-thumbs-prev]')?.addEventListener('click', () => strip?.scrollBy({left: -strip.clientWidth * .75, behavior: 'smooth'}));
      find('[data-thumbs-next]')?.addEventListener('click', () => strip?.scrollBy({left: strip.clientWidth * .75, behavior: 'smooth'}));
      const qty = find('[data-qty]');
      const quantity = () => Math.max(1, Math.floor(Number(qty?.value) || 1));
      find('[data-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, quantity() - 1); });
      find('[data-qty-plus]')?.addEventListener('click', () => { qty.value = quantity() + 1; });
      qty?.addEventListener('change', () => { qty.value = quantity(); });
      const variants = [...root.querySelectorAll('[data-variant-option]')];
      const add = find('[data-add-button]'), buy = find('[data-buy-now]');
      // A sold-out variant can be previewed, but must never submit the purchase form.
      find('.mfc-pdp2__form')?.addEventListener('submit', event => {
        if (add.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      find('.mfc-pdp2__form')?.addEventListener('submit', async event => {
        event.preventDefault();
        if (root.dataset.buyBusy === 'true' || add.disabled) return;
        root.dataset.buyBusy = 'true';
        const label = add.textContent;
        add.disabled = true; add.textContent = 'Adding…';
        let box = find('.mfc-pdp2__error');
        if (box) box.hidden = true;
        try {
          const route = window.Shopify?.routes?.root || '/';
          const response = await fetch(route + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(event.currentTarget)});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Unable to add product. Please try again.');
          await window.joviRefreshCart(true);
        } catch (error) {
          if (!box) {box=document.createElement('p');box.className='mfc-pdp2__error';box.setAttribute('role','alert');find('.mfc-pdp2__form').append(box);}
          box.textContent=error.message;box.hidden=false;
        } finally {root.dataset.buyBusy='false';add.disabled=false;add.textContent=label;}
      });
      variants.forEach(button => {
        button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
        button.addEventListener('click', () => {
          if (root.dataset.buyBusy === 'true') return;
          const data = button.dataset, available = data.available === 'true';
          find('[data-variant-id]').value = data.variantIdValue;
          find('[data-product-price]').innerHTML = data.price;
          find('[data-product-compare]').innerHTML = data.compare || '';
          const original = find('[data-product-original]');
          if (original) original.hidden = !data.compare;
          const save = find('[data-product-save]');
          if (save) { save.innerHTML = data.save || ''; save.hidden = !data.save; }
          if (find('[data-product-sku]')) find('[data-product-sku]').textContent = data.sku;
          if (find('[data-selected-variant]')) find('[data-selected-variant]').textContent = data.title;
          if (find('[data-variant-stock]')) find('[data-variant-stock]').hidden = available;
          showImage(data.image, data.imageAlt);
          find('[data-stock-text]').textContent = available ? 'In stock — ready to ship' : 'Out of stock';
          root.querySelector('.mfc-pdp2__stock i')?.classList.toggle('is-in', available);
          add.disabled = !available;
          add.textContent = available ? 'Add to cart' : 'Out of stock';
          if (buy) buy.disabled = !available;
          variants.forEach(item => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', String(item === button));
          });
          const url = new URL(location.href);
          url.searchParams.set('variant', data.variantIdValue);
          history.replaceState(history.state, '', url);
        });
      });
      buy?.addEventListener('click', async () => {
        const form = find('.mfc-pdp2__form');
        if (root.dataset.buyBusy === 'true' || buy.disabled || !form || !form.reportValidity()) return;
        const previousLabel = buy.textContent;
        root.dataset.buyBusy = 'true';
        buy.disabled = true;
        buy.setAttribute('aria-busy', 'true');
        buy.textContent = 'Processing…';
        let errorBox = find('.mfc-pdp2__error');
        if (errorBox) errorBox.hidden = true;
        try {
          const route = window.Shopify?.routes?.root || '/';
          const response = await fetch(route + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || 'Unable to add product. Please try again.');
          }
          location.assign(route + 'checkout');
        } catch (error) {
          if (!errorBox) {
            errorBox = document.createElement('p'); errorBox.className = 'mfc-pdp2__error';
            errorBox.setAttribute('role', 'alert'); form.append(errorBox);
          }
          errorBox.textContent = error.message; errorBox.hidden = false;
          buy.disabled = add.disabled;
          buy.textContent = previousLabel;
          buy.removeAttribute('aria-busy');
          root.dataset.buyBusy = 'false';
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
